import { BookmarkCheckIcon } from './BookmarkCheckIcon';

/**
 * author: Google
 * id 65F155F1-7A9F-49AF-B570-FD6D24553CE5
 * name bookmark-check
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookmark-check.svg
 * tags
 */
export const BookmarkTickIcon = BookmarkCheckIcon;
export default BookmarkTickIcon